import { render } from "./LaPhototheque.vue?vue&type=template&id=3948c759&ts=true"
import script from "./LaPhototheque.vue?vue&type=script&lang=ts"
export * from "./LaPhototheque.vue?vue&type=script&lang=ts"

import "./LaPhototheque.vue?vue&type=style&index=0&id=3948c759&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__